module.exports = __webpack_public_path__ + "img/banner2.118b3147.png";